import React from 'react'
import { withRouter, RouteComponentProps } from 'react-router'
import MarketingHeader from './MarketingHeader'
import StandardHeader from './StandardHeader'
import { withIdentity, WithIdentityProps } from '#src/containers/Identity'

interface ExternalHeaderProps {
  isDepartmentSpecificPage?: boolean
}

export interface HeaderProps
  extends ExternalHeaderProps,
    WithIdentityProps,
    RouteComponentProps<{}> {
  collapsable?: boolean
  transparent?: boolean
  textColor?: 'dark' | 'light'
  fixed?: boolean
  reserveSpace?: boolean
  className?: string
  hideSecondaryNav?: boolean
  stickyHeader?: JSX.Element
  stickyHeaderAfterScroll?: boolean
  replaceSearchWithPath?: boolean
  sidebar?: boolean
  sidebarConversationId?: string
  sidebarRecipientIds?: string[]
  sidebarExpertId?: string
  logoReplacement?: JSX.Element
  onlyShowMessagesAndCart?: boolean
}

const Header: React.SFC<HeaderProps> = ({ isDepartmentSpecificPage = true, myself, ...props }) => {
  // Only show the "marketing" header if:
  //  - The page isn't department specific (for example: "How it works", "About Curated", "FAQs")
  //  - The user is logged out
  if (!isDepartmentSpecificPage && !myself) {
    return <MarketingHeader {...props} />
  } else {
    return <StandardHeader {...props} />
  }
}

export default withRouter(withIdentity(Header))
